import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

export default function PasswordInput({ className = '', inputClassName = '', ...props }) {
  const [mostrar, setMostrar] = useState(false);

  return (
    <div className={`password-input ${className}`.trim()}>
      <input
        {...props}
        type={mostrar ? 'text' : 'password'}
        className={inputClassName || props.className || ''}
      />
      <button
        type="button"
        className="password-toggle"
        onClick={() => setMostrar((prev) => !prev)}
        aria-label={mostrar ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        tabIndex={-1}
      >
        {mostrar ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
  );
}
